import React from 'react';

export function LinkedIn() {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.8164 8.90821C17.8164 13.8285 13.8285 17.8164 8.90821 17.8164C3.98793 17.8164 0 13.8285 0 8.90821C0 3.98793 3.98793 0 8.90821 0C13.8285 0 17.8164 3.98793 17.8164 8.90821Z'
        fill='#2867B2'
      />
      <path
        d='M4.65598 7.35139H6.58169V13.5439H4.65598V7.35139ZM5.62028 4.27258C6.23605 4.27258 6.73563 4.77216 6.73563 5.39083C6.73563 6.00659 6.23605 6.50617 5.62028 6.50617C5.00452 6.50617 4.50494 6.00659 4.50494 5.39083C4.50494 4.77216 5.00162 4.27258 5.62028 4.27258Z'
        fill='white'
      />
      <path
        d='M7.78998 7.3514H9.63726V8.19952H9.6634C9.919 7.71156 10.5493 7.20036 11.4845 7.20036C13.4335 7.20036 13.7937 8.48126 13.7937 10.1485V13.5439H11.8709V10.5319C11.8709 9.81444 11.8592 8.8908 10.8688 8.8908C9.86672 8.8908 9.71568 9.67503 9.71568 10.4825V13.5468H7.79288V7.3514H7.78998Z'
        fill='white'
      />
    </svg>
  );
}

export function Pockets() {
  return (
    <svg
      width='20'
      height='19'
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <circle cx='10.0673' cy='9.21277' r='9.21277' fill='url(#pattern0)' />
      <defs>
        <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use xlinkHref='#image0_48:185' transform='scale(0.00444444)' />
        </pattern>
        <image
          id='image0_48:185'
          width='225'
          height='225'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  );
}

export function Facebook() {
  return (
    <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.3872 8.90821C18.3872 12.2007 16.603 15.0713 13.9498 16.6131C12.9804 17.1771 11.894 17.5615 10.7366 17.7245C10.3272 17.783 9.90514 17.8122 9.47895 17.8122C8.66418 17.8122 7.87865 17.7036 7.12655 17.4989C4.20589 16.705 1.88274 14.457 0.980217 11.5823C0.712803 10.7383 0.57074 9.83998 0.57074 8.90821C0.57074 3.98613 4.55687 0 9.47895 0C14.3969 0 18.3872 3.98613 18.3872 8.90821Z'
        fill='#196BCE'
      />
      <path
        d='M10.7325 7.23269V9.74804H12.667L11.9567 12.6102H10.7325V17.7287C10.323 17.7872 9.90097 17.8164 9.47478 17.8164C8.66 17.8164 7.87447 17.7078 7.12237 17.503V12.606H5.18781V9.74387H7.12237V5.67417C7.12237 3.85241 8.62657 2.39417 10.4483 2.44849L13.7617 2.59473V5.70759L12.1197 5.80369C11.3467 5.82876 10.7325 6.45969 10.7325 7.23269Z'
        fill='white'
      />
    </svg>
  );
}

export function Arrow({ ...props }) {
  return (
    <svg width='16' height='19' viewBox='0 0 16 19' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M8.70711 0.292892C8.31658 -0.0976315 7.68342 -0.0976314 7.29289 0.292892L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292892ZM9 19L9 1L7 1L7 19L9 19Z'
        fill='#1547CD'
      />
    </svg>
  );
}

export function XCircle({ ...props }) {
  return (
    <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='7.5' cy='7.5' r='7.5' fill='#D4D4DF' />
      <path
        d='M8.07143 7.48031L9.88095 5.68504C10.0397 5.52756 10.0397 5.27559 9.88095 5.11811C9.72222 4.96063 9.46825 4.96063 9.30952 5.11811L7.5 6.94488L5.69048 5.14961C5.53175 4.99213 5.27778 4.99213 5.11905 5.14961C4.96032 5.30709 4.96032 5.55906 5.11905 5.71654L6.92857 7.51181L5.11905 9.30709C4.96032 9.46457 4.96032 9.71654 5.11905 9.87402C5.18254 9.93701 5.30952 10 5.40476 10C5.5 10 5.59524 9.9685 5.69048 9.87402L7.5 8.07874L9.30952 9.87402C9.37302 9.93701 9.5 10 9.59524 10C9.69048 10 9.78571 9.9685 9.88095 9.87402C10.0397 9.71654 10.0397 9.46457 9.88095 9.30709L8.07143 7.48031Z'
        fill='white'
      />
    </svg>
  );
}
